import * as Yup from 'yup';

const validationSchema = Yup.object({
    channel_email: Yup.string().email('Please enter Valid Email'),
});
export default validationSchema;